import { render, staticRenderFns } from "./realUsageDetail.vue?vue&type=template&id=0fde7e43&scoped=true&"
import script from "./realUsageDetail.vue?vue&type=script&lang=js&"
export * from "./realUsageDetail.vue?vue&type=script&lang=js&"
import style0 from "./realUsageDetail.vue?vue&type=style&index=0&id=0fde7e43&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fde7e43",
  null
  
)

export default component.exports